import gql from 'graphql-tag';

import { listResourceQueryDefinitions, deleteResourceMutationDefinitions } from '@/providers/graphql/resourceQueryDefinitions';

export const CONTRACTS_LIST_QUERY = gql`
        query ContractsList($first: Int, $after: String) {
                contracts(first: $first, after: $after) {
                        nodes {
                                contractId
                                contractNumber
                                beginDate
                                endDate
                                amount
                                simultaneousVehicleLimit
                                reservedParkingSlots
                                isActive
                                isAutoRenewed
                                preferredLanguage
                                customer {
                                        customerId
                                        firmName
                                        firstName
                                        lastName
                                        isCompany
                                        customerCategory {
                                                description
                                                simultaneousVehicleLimit
                                        }
                                }
                                contractVehicles {
                                        contractVehicleId
                                        vehicleId
                                        rfidTag
                                        isVip
                                        vehicle {
                                                vehicleId
                                                plateNumber
                                                make
                                                model
                                                color
                                        }
                                }
                                parkingSessions {
                                        parkingSessionId
                                        entryDateTime
                                        exitDateTime
                                                        isInside
                                }
                        }
                        pageInfo {
                                hasNextPage
                                endCursor
                        }
                }
        }
`;

export const CONTRACT_LIST_ITEM_QUERY = gql`
        query ContractListItem($contractId: Ulid!) {
                contract(contractId: $contractId) {
                        contractId
                        contractNumber
                        beginDate
                        endDate
                        amount
                        simultaneousVehicleLimit
                        reservedParkingSlots
                        isActive
                        isAutoRenewed
                        preferredLanguage
                        customer {
                                customerId
                                firmName
                                firstName
                                lastName
                                isCompany
                                customerCategory {
                                        description
                                        simultaneousVehicleLimit
                                }
                        }
                        contractVehicles {
                                contractVehicleId
                                vehicleId
                                rfidTag
                                isVip
                                vehicle {
                                        vehicleId
                                        plateNumber
                                        make
                                        model
                                        color
                                }
                        }
                        parkingSessions {
                                parkingSessionId
                                entryDateTime
                                exitDateTime
                                                isInside
                        }
                }
        }
`;

export const CONTRACT_DETAIL_QUERY = gql`
        query ContractDetail($contractId: Ulid!) {
                contract(contractId: $contractId) {
                        contractId
                        contractNumber
                        beginDate
                        endDate
                        amount
                        isAutoRenewed
                        simultaneousVehicleLimit
                        reservedParkingSlots
                        isActive
                        preferredLanguage
                        customer {
                                customerId
                                firmName
                                firstName
                                lastName
                                isCompany
                                customerCategory {
                                        description
                                        simultaneousVehicleLimit
                                }
                        }
                        contractVehicles {
                                contractVehicleId
                                vehicleId
                                rfidTag
                                isVip
                                vehicle {
                                        plateNumber
                                        vehicleType {
                                                name
                                        }
                                        make
                                        model
                                        color
                                }
                        }
                        parkingSessions {
                                parkingSessionId
                                entryDateTime
                                exitDateTime
                                                isInside
                        }
                }
        }
`;

export const CONTRACTS_PANEL_BY_CUSTOMER_QUERY = gql`
	query ContractsPanelByCustomer(
		$customerId: Ulid!
		$first: Int
		$after: String
	) {
		contracts(
			first: $first
			after: $after
			order: [{ beginDate: DESC }]
			where: { customerId: { eq: $customerId } }
		) {
			nodes {
				contractId
				contractNumber
				customerId
				beginDate
				endDate
				amount
				simultaneousVehicleLimit
				isActive
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const CONTRACTS_PANEL_BY_VEHICLE_QUERY = gql`
	query ContractsPanelByVehicle($vehicleId: Ulid!) {
		vehicle(vehicleId: $vehicleId) {
			vehicleId
			contractVehicles {
				contractVehicleId
				contract {
					contractId
					contractNumber
					beginDate
					endDate
					amount
					simultaneousVehicleLimit
					isActive
				}
			}
		}
	}
`;



export const CREATE_CONTRACT_MUTATION = gql`
        mutation CreateContract($input: CreateContractInput!) {
                createContract(input: $input) {
                        success
                        errorCode
                        errorDescription
                        isErrored
                        failed
                }
        }
`;

export const UPDATE_CONTRACT_MUTATION = gql`
        mutation UpdateContract($input: UpdateContractInput!) {
                updateContract(input: $input) {
                        success
                        errorCode
                        errorDescription
                        isErrored
                        failed
                }
        }
`;

export const DELETE_CONTRACT_MUTATION = gql`
        mutation DeleteContract($input: DeleteContractInput!) {
                deleteContract(input: $input) {
                        success
                        errorCode
                        errorDescription
                        isErrored
                        failed
                }
        }
`;

// Lookup queries for form options
export const CUSTOMERS_QUERY = gql`
        query Customers {
                customers(first: 50) {
                        nodes {
                                customerId
                                firmName
                                email
                                customerCategory {
                                        description
                                        simultaneousVehicleLimit
                                }
                        }
                }
        }
`;

export const VEHICLES_QUERY = gql`
        query Vehicles {
                vehicles(first: 50) {
                        nodes {
                                vehicleId
                                plateNumber
                                make
                                model
                                color
                        }
                }
        }
`;

listResourceQueryDefinitions['contracts'] = {
        document: CONTRACTS_LIST_QUERY,
        dataPath: 'contracts.nodes'
};

deleteResourceMutationDefinitions['contracts'] = {
	document: DELETE_CONTRACT_MUTATION,
	operation: 'deleteContract',
	getVariables: variables => ({ input: variables })
};
